import { Box } from '@mui/material';
import { TabPanelProps } from 'src/types/TabPanelProps';

export const TabPanel: React.FC<TabPanelProps> = props => {
  const { children, value, index } = props;
  return value === index ? (
    <div {...props.tabContainer}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </div>
  ) : (
    <></>
  );
};
